/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

/**
 *
 *
 * 0 = ACTIVE
 *
 * 1 = DECEASED
 *
 * 2 = CUSTOMER
 *
 * 3 = PROSPECT
 */
export enum CustomerStatus {
  ACTIVE = 0,
  DECEASED = 1,
  CUSTOMER = 2,
  PROSPECT = 3,
}
